module.exports = __webpack_public_path__ + "img/logo-otp-new.9073811b.png";